/// <reference path="../../app.definition.ts" />

import angular from 'angular';
import { Util } from '@common/util';
import { JavaApiAdapterService } from '@common/apiadapter/javaapi.service';
import { PopUpService } from '@common/popup/popup.service';
import { CacheService } from '@common/service/cache.service';

export class PaymentService {
  private checkThreshold: Function;
  public checkLimitAndProceed: Function;
  public getPopupTitle: Function;
  public getPopupMessage: Function;
  private getStringValues: Function;
  public getToastrMessage: Function;

  static $inject = ["$q", "$rootScope", "ApiAdapterService", "PopUpService"];
  constructor(
    $q,
    $rootScope,
    private $_api: JavaApiAdapterService,
    private $_popup: PopUpService,
    private $_cache: CacheService
  ) {
    this.checkThreshold = (type: string) => {
      var deferred = $q.defer();

      this.$_api.getCurrentSubscribePlanForUser(false).then(
        (s) => {
          if (type == "team") {
            if (s.maxCR < 0 || s.currentUsage.careTeam < s.maxCR) {
              deferred.resolve({
                allowed: true,
                maxAllowed: s.maxCareTeams
              });
            } else {
              deferred.resolve({
                allowed: false,
                maxAllowed: s.maxCareTeams
              });
            }
          } else if (type == "document") {
            if (s.maxDocuments < 0 || s.currentUsage.documents < s.maxDocuments) {
              deferred.resolve({
                allowed: true,
                maxAllowed: s.maxDocuments
              });
            } else {
              deferred.resolve({
                allowed: false,
                maxAllowed: s.maxDocuments
              });
            }
          } else if (type == "discussion") {
            if (s.maxDiscussions < 0 || s.currentUsage.discussions < s.maxDiscussions) {
              deferred.resolve({
                allowed: true,
                maxAllowed: s.maxDiscussions
              });
            } else {
              deferred.resolve({
                allowed: false,
                maxAllowed: s.maxDiscussions
              });
            }
          } else if (type == "photo") {
            if (s.maxGalleryPhotos < 0 || s.currentUsage.galleryPhotos < s.maxGalleryPhotos) {
              deferred.resolve({
                allowed: true,
                maxAllowed: s.maxGalleryPhotos
              });
            } else {
              deferred.resolve({
                allowed: false,
                maxAllowed: s.maxGalleryPhotos
              });
            }
          }
        },
        (e) => {
          deferred.reject(e);
        }
      );

      return deferred.promise;
    }

    this.checkLimitAndProceed = (type: string, callback?: Function, hidePopup?: boolean) => {
      var deferred = $q.defer();

      var hide = false;
      if (!!hidePopup && hidePopup == true) {
        hide = true;
      }

      $rootScope.mainShowLoader = true;

      this.checkThreshold(type).then((s) => {
        $rootScope.mainShowLoader = false;

        if (s.allowed == true) {
          deferred.resolve(true);
          if (!!callback) {
            callback();
          }
        } else {
          var popupTitle = this.getPopupTitle(type);
          var popupMessage = this.getPopupMessage(type);
          if (hide != true) {
            this.$_popup.openAccountLimitAlertPopup(popupTitle, popupMessage).then((s) => {
              deferred.reject(s);
            }, (e) => {
              deferred.reject(e);
              console.log(e);
            });
          } else {
            deferred.reject(false);
          }
        }
      }, (e) => {
        $rootScope.mainShowLoader = false;
        deferred.reject(false);
        console.log(e);
      });

      return deferred.promise;
    }

    this.getPopupTitle = (type: string) => {
      var str = this.getStringValues(type);

      var title = Util.ACCOUNT_LIMIT_POPUP_TITLE;
      title = title.replace('$entity', str.entity);
      return title;
    }

    this.getPopupMessage = (type: string) => {
      var str = this.getStringValues(type);

      var msg = Util.ACCOUNT_LIMIT_POPUP_MESSAGE;
      msg = msg.replace('$entity', str.entity);
      msg = msg.replace('$action', str.action);
      return msg;
    }

    this.getToastrMessage = (type: string) => {
      var str = this.getStringValues(type);

      var msg = Util.ACCOUNT_UPLOAD_LIMIT_MESSAGE.replace('$entity', str.entity).replace('$action', str.action);
      return msg;
    }

    this.getStringValues = (type: string) => {
      var entity = "";
      var action = "";

      if (type == "team") {
        entity = "Care Team";
        action = "can create";
      } else if (type == "document") {
        entity = "Document";
        action = "are able to upload across all Teams";
      } else if (type == "discussion") {
        entity = "Discussion";
        action = "are able to start across all Teams";
      } else if (type == "photo") {
        entity = "Photo";
        action = "are able to upload across all Teams";
      }

      return {
        "entity": entity,
        "action": action
      };
    }
  }
}

angular.module('eCareVault.common.services')
  .service('PaymentService', PaymentService);